import { h, Component } from 'preact';
import { joinClasses, accessNested } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import Store from 'store/store';
import s from 'components/templates/hero/hero.sss';
import HTML from 'components/core/html/html';

export default class Hero extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(evt) {
		evt.preventDefault();
		smoothScrollTo(document.body, 500, 500);
	}
	render({ data, isDesktop, active }) {
		let {
			id,
			src,
			title,
			subtitle
		} = data;

		const regionToggleUsed = accessNested(Store.get(), 'appData.header.regionToggle');

		// src = isDesktop ? src.desktop : src.mobile;
		// const type = src.includes('.mp4') ? 'video' : 'image';
		// const asset = (
		// 	type === 'video' ? (
		// 		<video class={s.asset} src={src} />
		// 	) : (
		// 		<img class={s.asset} src={src} />
		// 	)
		// )
		return (
			<div class={joinClasses(s.wrapper, active && s.active, regionToggleUsed && s.regionToggleUsed)} id='hero' data-section-observed>
				<div class={s.txtContainer}>
					<HTML tag="h1" class={s.title} content={title} markdown />
					<HTML tag="h2" class={s.subtitle} content={subtitle} markdown />
				</div>
				<button class={s.scroll} onClick={this.handleClick}/>
			</div>
		);
	}

}
